"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";

/**
 * PostHog PageView tracking component for marketing site
 * Tracks all pageviews and maintains affiliate attribution
 */
export default function PostHogPageView(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();

  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname;
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }

      // Capture affiliate if present in URL and not already registered
      const affiliate = searchParams.get('affiliate');
      if (affiliate) {
        const currentAffiliate = posthog.get_property('affiliate');
        if (currentAffiliate !== affiliate) {
          posthog.register({
            affiliate: affiliate,
            initial_affiliate: posthog.get_property('initial_affiliate') || affiliate,
          });
          localStorage.setItem('affiliate', affiliate);
        }
      }

      // Capture pageview with all properties
      posthog.capture("$pageview", {
        $current_url: url,
        // Include referrer for attribution
        $referrer: document.referrer || undefined,
      });
    }
  }, [pathname, searchParams, posthog]);

  return null;
}
